import { render, staticRenderFns } from "./userWhitelist.vue?vue&type=template&id=dc5c2a52&scoped=true"
import script from "./userWhitelist.vue?vue&type=script&lang=js"
export * from "./userWhitelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5c2a52",
  null
  
)

export default component.exports